import axios from 'axios';
import { normalize } from 'normalizr';
import { createSlice } from '@reduxjs/toolkit';
import { setError } from './uiReducer';
import { provider } from '../actions/NormalizrSchema';
import { getObjectKeys, mergeShallow } from '../helpers/DataHelpers';
import NotificationService from '../services/NotificationService';

// SLICE
const providerSlice = createSlice({
  name: 'PROVIDER',
  initialState: {
    providers: {},
    providerIds: [],
    loading: false,
    total: 0,
    pageLoading: false,
  },
  reducers: {
    receiveProviders: (state, action) => ({
      ...state,
      providers: mergeShallow(state.providers, action.payload.providers),
      providerIds: [...new Set([...state.providerIds, ...action.payload.providerIds])],
      loading: false,
      pageLoading: false,
      total: action.payload.total,
    }),
    requestData: (state) => ({
      ...state,
      loading: true,
    }),
    requestPagedData: (state) => ({
      ...state,
      pageLoading: true,
    }),
    receiveError: (state) => ({
      ...state,
      loading: false,
    }),
  },
});

export default providerSlice.reducer;

// ACTIONS
export const { receiveProviders, requestData, receiveError, requestPagedData } = providerSlice.actions;

// THUNKS -- ASYNC ACTION CREATORS
export function fetchProviders(orgId, pageNo, pageSize) {
  return (dispatch) => {
    if (pageNo === 0) {
      dispatch(requestData());
    } else {
      dispatch(requestPagedData());
    }
    return axios.get(`/providers/${orgId}?pageSize=${pageSize}&page=${pageNo}`)
      .then(((response) => {
        const { providers, total } = response.data;
        const normalizedProviders = normalize(providers, [provider]);
        dispatch(receiveProviders(getProviderPayload(normalizedProviders, total)));
      }))
      .catch((err) => {
        dispatch(receiveError());
        dispatch(setError(err));
      });
  };
}

export function fetchProviderPerAppointments(orgId, isUpcoming = true) {
  return (dispatch) => {
    dispatch(requestData());
    return axios.get(`/appointment/providers/${orgId}?isUpcoming=${isUpcoming}`)
      .then(((response) => {
        const normalizedProviders = normalize(response.data, [provider]);
        dispatch(receiveProviders(getProviderPayload(normalizedProviders)));
      }))
      .catch((err) => {
        dispatch(receiveError());
        dispatch(setError(err));
      });
  };
}

export function updateProviders(orgId, payload) {
  return (dispatch) =>
    axios.patch(`/providers/${orgId}`, payload)
      .then((response) => {
        NotificationService('updateProvider', response);
        fetchProviders(orgId);
      })
      .catch((error) => {
        NotificationService('updateProvider', error.response);
        dispatch(setError(error.response || error));
        console.error(error);
      });
}

function getProviderPayload(normalizedProviders, total) {
  return {
    providers: {
      ...normalizedProviders.entities.provider,
    },
    providerIds: getObjectKeys(normalizedProviders.entities.provider),
    total,
  };
}
